/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nights: NonNullable<unknown>, avg: NonNullable<unknown> }} Price_Breakdown_Toggle_NightsInputs */

const en_price_breakdown_toggle_nights = /** @type {(inputs: Price_Breakdown_Toggle_NightsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} nights × ${i?.avg} avg`)
};

/**
* | output |
* | --- |
* | "{nights} nights × {avg} avg" |
*
* @param {Price_Breakdown_Toggle_NightsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_toggle_nights = /** @type {((inputs: Price_Breakdown_Toggle_NightsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Toggle_NightsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_toggle_nights(inputs)
});